<template>
  <div :class="[{'row': !noRow}, `col-lg-${grid.columns} ${className ? className : ''}`]" :style="{ ...styles, ...cssVars }">
    <template v-for="field in fields">
      <componentRenderer
        :class="`col-lg-${field.properties.grid.columns}`"
        :field="field"
        v-bind:key="field.id"
        v-on:component-updated="updated"
      />
    </template>
  </div>
</template>
<script>
import componentRenderer from "@/components/component-renderer";

export default {
  name: "empty-bucket",
  components: { componentRenderer },
  props: {
    fieldId: String,
    requires: Array,
    fields: {
      type: Array,
      required: true
    },
    grid: {
      type: Object
    },
    noRow: {
      type: Boolean,
      default: false
    },
    styles: {
      type: Object,
      default: () => {
        return {};
      }
    },
    className: String
  },
  methods: {
    updated(field, properties) {
      let updatedField = this._.find(this.fields, function(fld) {
        return fld.fieldId === field.fieldId;
      });

      updatedField.properties = { ...updatedField.properties, ...properties };
      // let updatedField = __.findDeep(this.fields, fld => fld === field.fieldId);
      // console.log(
      //   "component renderer on updated::",
      //   field,
      //   "properties",
      //   properties,
      //   "FOUND",
      //   updatedField
      // );

      // TODO
      // some validation will go here
      // in case if all fields are valid we are happy to set truthy status
      this.$store.dispatch("setComponentStatus", {
        component: this.fieldId,
        status: true
      });
    }
  }
};
</script>
<style scoped lang="scss">
.row {
  ::v-deep [disabled] {
    opacity: 0.65;
    pointer-events: none;
  }
}
.box-shadow {
  background-color: rgba(255, 255, 255, 0.7);
  box-shadow: 0 0 160px 90px white,
  0 0 10px 1px white,
  inset 0 0 10px 1px white;
  @media (max-width: 400px) {
    box-shadow: 0 0 160px 90px white,
  0 0 10px 1px white,
  inset 0 0 10px 1px white;
  }
}
</style>
